// Espera as fontes do documento ficarem prontas antes de um window.print().
// react-to-print clona o DOM num iframe; se as fontes ainda não carregaram o
// PDF sai com glifos trocados/embaralhados. Promise.race com timeout para
// nunca travar o print (mesmo padrão do waitForLogoReady em useLogoPreloader).
export const waitForFontsReady = (timeoutMs = 3000) => {
  const hasFontsApi =
    typeof document !== 'undefined' && document.fonts && document.fonts.ready;
  if (!hasFontsApi) return Promise.resolve();

  return Promise.race([
    document.fonts.ready,
    new Promise((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
};
